module.exports = __webpack_public_path__ + "media/Audio15_b.95e8a96a.wav";